<div *ngIf="showProgress">
    <mat-progress-bar class="progress-bar-margin" mode="indeterminate"></mat-progress-bar>
</div>
<div class="search-result-container" *ngIf="showContactResult">
    <xp-contact-result></xp-contact-result>
</div>
